var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { CustomReportAFY } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import React from "react";
import { Filters } from "../resources/reportsSumaries.DTO";
export var ReportsSumariesView = function (props) {
    return (_jsx(React.Fragment, { children: _jsx("div", __assign({ style: { width: "calc(100vw - 275px)" } }, { children: _jsx(CustomReportAFY, { titleButtonBack: "Regresar", titlePage: props.reportName, descriptionPage: "Si desea aplicar un filtro al resultado de ventas completadas, seleccione el filtro deseado que se muestra a continuaci\u00F3n.", widthTable: "100%", heightTable: "673px", filters: Filters, columnsTable: props.columns, rowsTable: props.rows, pageSizeTable: 11, onChangeFilter: props.onChangeFilter, onClickBack: props.onBack, onClickClearFilters: props.onClearFilter, onBlurFullTextSearch: function noRefCheck() { }, onChangeFullTextSearch: function noRefCheck() { }, onClickExportButton: function (e) {
                    var _a;
                    (_a = props.onExportReport) === null || _a === void 0 ? void 0 : _a.call(props, e);
                } }) })) }));
};
